
/// <reference path="../../../../setup/_references.ts" />
module onvio.clientDashboard.ClientAssignmentsItemComponent {
    'use strict';

    export class ClientAssignmentsItemController {
        public employee: cs.IEmployeeWithExpansionV3Dto;
        public subString: string;

        private displayEmailButton(): boolean {
            let emailAddresses = this.employee.primaryContactExpanded.emailAddresses;
            let index = _.find(emailAddresses, (emailAddress: cs.IContactEmailV2Dto) => emailAddress.isPrimary);
            return angular.isDefined(index);
        }

        private generateMailToLink(): string {
            let emailAddresses = this.employee.primaryContactExpanded.emailAddresses;
            let primaryEmail = _.find(emailAddresses, (emailAddress: cs.IContactEmailV2Dto) => emailAddress.isPrimary);
            return `mailto:${primaryEmail.emailAddress}`;
        }
    }

    export class ClientAssignmentsItemComponent implements ng.IComponentOptions {
        bindings: any = {
            employee: '<',
            subString: '@'
        };
        controller = ClientAssignmentsItemController;
        templateUrl = 'client-dashboard/components/client-assignments-component/client-assignments-item-component/client-assignments-item-component.html';
    }

    angular.module('onvio.clientDashboard.ClientAssignmentsItemComponent', ['bmProfilePhoto'])
            .component('clientAssignmentsItem', new ClientAssignmentsItemComponent());
}
